<template>
  <DxSelectBox
    id="custom-templates"
    :data-source="getDataSource"
    :on-value-changed="onSelectionChanged"
    :display-expr="displayExpr"
    :value-expr="valueExpr"
    :searchEnabled="true"
    :openOnFieldClick="true"
    searchMode="contains"
    :searchExpr="searchExpr"
    :itemTemplate="itemTemplate"
    :showClearButton="showClearButton"
    @initialized="initialized"
    ref="gc-select-box"
    :validationMessageMode="validationMessageMode"
    @itemClick="onItemClick"
    :value="value"
    :readOnly="setReadOnly"
    :fieldTemplate="fieldTemplate"
    :dropDownOptions="dropDownOptions"
    @opened="onOpened"
    :acceptCustomValue="acceptCustomValue"
    @customItemCreating="onCustomItemCreating"
    @enter-key="onPressEnterKey"
    @key-down="onKeyDown"
  >
    <template #item-template="{ data }">
      <div class="custom-auto-complete">
        <span class="auto-complete-primary">{{ data[primaryText] }}</span>
        <span class="auto-complete-secondary">{{ data[secondaryText] }}</span>
      </div>
    </template>

    <template #multi-item-template="{ data }">
      <div class="custom-auto-complete">
        <span class="auto-complete-primary">
          {{ data[primaryText] }}
        </span>
        <div
          v-for="(item, index) in secondaryItems(data)"
          :key="index"
          class="record-secondary gc-grid-code"
        >
          {{ item }}
        </div>
      </div>
    </template>

    <template #default-item-template="{ data }">
      <div>
        <span v-if="typeof data === 'string'">{{ data }}</span>
        <span v-else>{{ data[dataField] }}</span>
      </div>
    </template>

    <template #field-template="{ data }">
      <!-- <div class="gc-auto-cmp">{{ data.Description }}</div> -->
      <div class="custom-auto-complete">
        <DxTextBox
          :value="getPrimaryText(data)"
          :read-only="setReadOnly"
          class="product-name auto-complete-primary"
        />
        <span
          v-if="data && fieldSecondaryText"
          class="auto-complete-secondary"
          >{{ data[fieldSecondaryText] }}</span
        >
      </div>
    </template>
  </DxSelectBox>
</template>
<script>
import DxSelectBox from "devextreme-vue/select-box";
import { GridReportService } from "../_services/api/reports/grid-report.service";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";

export default {
  components: {
    DxSelectBox,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    selectBoxOptions: {
      type: [Object, Array],
      default: () => {},
    },
    gridData: {
      type: Object,
      default: () => {},
    },
    value: {
      type: String,
      default: undefined,
    },
    showClearButton: {
      type: Boolean,
      default: true,
    },
    setReadOnly: {
      type: Boolean,
      default: false,
    },
    customFilter: {
      type: [Array, Object],
      default: () => {},
    },
    parentRowData: {
      type: [Array, Object],
      default: () => {},
    },
    acceptCustomValue: {
      type: Boolean,
      default: false,
    },
    onPressEnterKey: {
      type: Function,
      default: () => {},
    },
    onCellValueChanged: {
      type: Function,
      default: () => function () {},
    },
    cellField: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      datasource: this.selectBoxOptions[0].dataSourceConfig.endpoint
        ? GridReportService.dataSourceConfig(
            this.selectBoxOptions[0].dataSourceConfig.endpoint,
            {
              select: this.selectBoxOptions[0].dataSourceConfig.select
                ? this.selectBoxOptions[0].dataSourceConfig.select
                : [
                    this.selectBoxOptions[0].valueExpr,
                    this.selectBoxOptions[0].displayExpr,
                  ],
              sort: this.selectBoxOptions[0].dataSourceConfig.sort
                ? this.selectBoxOptions[0].dataSourceConfig.sort
                : undefined,
              filter: this.selectBoxOptions[0].dataSourceConfig.filter
                ? this.selectBoxOptions[0].dataSourceConfig.filter
                : this.customFilter
                ? this.customFilter
                : undefined,
              keyType: this.selectBoxOptions[0].dataSourceConfig.keyType
                ? this.selectBoxOptions[0].dataSourceConfig.keyType
                : undefined,
              fieldTypes: this.selectBoxOptions[0].dataSourceConfig.fieldTypes
                ? this.selectBoxOptions[0].dataSourceConfig.fieldTypes
                : undefined,
            }
          )
        : undefined,
      items: this.selectBoxOptions[0].dataSourceConfig.customData
        ? this.selectBoxOptions[0].dataSourceConfig.customData(
            this.gridData,
            this.parentRowData
          )
        : this.selectBoxOptions[0].dataSourceConfig.data
        ? this.selectBoxOptions[0].dataSourceConfig.data
        : undefined,
      valueExpr: this.selectBoxOptions[0].valueExpr
        ? this.selectBoxOptions[0].valueExpr
        : undefined,
      displayExpr: this.selectBoxOptions[0].displayExpr
        ? this.selectBoxOptions[0].displayExpr
        : undefined,
      searchExpr: this.selectBoxOptions[0].searchExpr
        ? this.selectBoxOptions[0].searchExpr
        : this.selectBoxOptions[0].displayExpr
        ? [
            this.selectBoxOptions[0].valueExpr,
            this.selectBoxOptions[0].displayExpr,
          ]
        : undefined,
      primaryText: this.selectBoxOptions[0].editorTemplate
        ? this.selectBoxOptions[0].editorTemplate.primary[0].dataField
        : undefined,
      secondaryText: this.selectBoxOptions[0].editorTemplate
        ? this.selectBoxOptions[0].editorTemplate.secondary
          ? this.selectBoxOptions[0].editorTemplate.secondary[0].dataField
          : undefined
        : undefined,
      itemTemplate: this.selectBoxOptions[0].editorTemplate
        ? "item-template"
        : "default-item-template",
      // showClearButton: true,
      //   widgetItem: this.selectBoxOptions.editorType,
      dataField: this.selectBoxOptions[0].dataField,
      defaultValue: this.selectBoxOptions[0].defaultValue
        ? this.selectBoxOptions[0].defaultValue
        : undefined,
      validationMessageMode: this.selectBoxOptions[0].validationMessageMode
        ? this.selectBoxOptions[0].validationMessageMode
        : "auto",
      readOnly: this.selectBoxOptions[0].readOnly || this.setReadOnly,
      fieldTemplate: this.selectBoxOptions[0].fieldTemplate
        ? "field-template"
        : null,
      dropDownOptions: this.selectBoxOptions[0].dropDownOptions
        ? this.selectBoxOptions[0].dropDownOptions
        : undefined,
      secondary: [],
      fieldPrimaryText: this.selectBoxOptions[0].fieldTemplate
        ? this.selectBoxOptions[0].fieldTemplate.primary
          ? this.selectBoxOptions[0].fieldTemplate.primary[0].dataField
          : this.selectBoxOptions[0].editorTemplate
          ? this.selectBoxOptions[0].editorTemplate.primary[0].dataField
          : undefined
        : undefined,
      fieldSecondaryText: this.selectBoxOptions[0].fieldTemplate
        ? this.selectBoxOptions[0].fieldTemplate.primary &&
          this.selectBoxOptions[0].fieldTemplate.secondary
          ? this.selectBoxOptions[0].fieldTemplate.secondary[0].dataField
          : !this.selectBoxOptions[0].fieldTemplate.primary &&
            this.selectBoxOptions[0].editorTemplate
          ? this.selectBoxOptions[0].editorTemplate.secondary
            ? this.selectBoxOptions[0].editorTemplate.secondary[0].dataField
            : undefined
          : undefined
        : undefined,

      // acceptCustomValue: this.selectBoxOptions[0].acceptCustomValue
      //   ? this.selectBoxOptions[0].acceptCustomValue
      //   : false,

      // fieldSecondaryText: this.selectBoxOptions[0].fieldTemplate ? this.selectBoxOptions[0].fieldTemplate.primary &&
      //   this.selectBoxOptions[0].fieldTemplate.secondary ? this.selectBoxOptions[0].fieldTemplate.secondary[0].dataField  : undefined: undefined
    };
  },
  created() {
    if (
      this.selectBoxOptions[0].editorTemplate &&
      this.selectBoxOptions[0].editorTemplate.secondary &&
      this.selectBoxOptions[0].editorTemplate.secondary.length > 1
    ) {
      this.itemTemplate = "multi-item-template";
      this.secondary = this.selectBoxOptions[0].editorTemplate.secondary;
    }
  },
  methods: {
    onCustomItemCreating(e) {
      if (this.selectBoxOptions[0].onCustomItemCreating) {
        if (this.parentRowData) {
          this.valueChangeCallBack(e, this.gridData, this.parentRowData);
        } else {
          this.valueChangeCallBack(e, this.gridData, null);
        }
      }
    },
    getPrimaryText(data) {
      return data
        ? this.fieldPrimaryText
          ? data[this.fieldPrimaryText]
          : data[this.primaryText]
        : "";
    },
    onOpened(e) {
      this.selectBoxOptions[0].editorOptions &&
      this.selectBoxOptions[0].editorOptions.onOpened
        ? this.selectBoxOptions[0].editorOptions.onOpened(
            e,
            this.gridData,
            this.parentRowData
          )
        : {};
    },
    onKeyDown(e) {
      this.selectBoxOptions[0].editorOptions &&
      this.selectBoxOptions[0].editorOptions.onKeyDown
        ? this.selectBoxOptions[0].editorOptions.onKeyDown(
            e,
            this.gridData,
            this.parentRowData
          )
        : {};
    },
    onSelectionChanged(e) {
      if (this.cellField) {
        this.onCellValueChanged(e.value);
      } else {
        let filter = [];
        var setFilter = [];

        if (e.value !== null && e.value !== undefined && e.value !== "") {
          setFilter = [];
          setFilter[0] = this.selectBoxOptions[0].dataField;
          setFilter[1] = "=";
          setFilter[2] = e.value;
          filter.push(setFilter);
        }

        if (this.selectBoxOptions[0].formLocation == "form-report") {
          this.valueChangeCallBack(this.dataField, e.value);
        } else if (this.selectBoxOptions[0].formLocation == "data-grid") {
          // onItemClick handles mouse clicks; this branch covers keyboard selection (arrow + Enter)
          if (this._itemClickFired) {
            this._itemClickFired = false;
            return;
          }
          if (e.value !== null && e.value !== undefined && e.component) {
            var selectedItem = e.component.option("selectedItem");
            if (selectedItem) {
              var syntheticEvent = { itemData: selectedItem };
              if (this.parentRowData)
                this.valueChangeCallBack(syntheticEvent, this.gridData, this.parentRowData);
              else this.valueChangeCallBack(syntheticEvent, this.gridData);
            }
          }
          return;
        } else this.valueChangeCallBack(this.dataField, filter);
      }
    },
    initialized(e) {
      if (this.defaultValue) {
        var defaultValue = undefined;
        if (Array.isArray(this.defaultValue)) {
          defaultValue = this.defaultValue[0];
        } else defaultValue = this.defaultValue;
        e.component.beginUpdate();
        e.component.option("value", defaultValue);
        e.component.endUpdate();

        if (defaultValue) this.onSelectionChanged({ value: defaultValue });
      }
    },
    onItemClick(e) {
      if (this.selectBoxOptions[0].formLocation == "data-grid") {
        this._itemClickFired = true;
        if (this.parentRowData)
          this.valueChangeCallBack(e, this.gridData, this.parentRowData);
        else this.valueChangeCallBack(e, this.gridData);
      }
    },
    secondaryItems(data) {
      let secondaryArr = [];
      let str = "";
      this.secondary.forEach((el, i) => {
        if (data[el.dataField] == null) {
          return;
        }
        if (el.position === "below") {
          if (str) {
            secondaryArr.push(str);
            str = "";
          }
          if (
            i == this.secondary.length - 1 ||
            (this.secondary[i + 1] !== undefined &&
              this.secondary[i + 1].position === "below")
          )
            secondaryArr.push(data[el.dataField]);
          else str = str + data[el.dataField];
        } else if (el.position === "append" || !el.position) {
          if (
            data[el.dataField] !== "" &&
            data[el.dataField] !== null &&
            data[el.dataField] !== undefined
          ) {
            str = str
              ? str + " " + el.label + ": " + data[el.dataField]
              : data[el.dataField];
          }
          if (i == this.secondary.length - 1) {
            secondaryArr.push(str);
            str = "";
          }
        }
      });

      return secondaryArr;
    },
  },
  computed: {
    getLocalItemsList() {
      if (!this.items || this.items.length == 0) return undefined;
      else {
        return new DataSource({
          paginate: true,
          pageSize: 20,
          store: new ArrayStore({
            type: "array",
            data: this.items,
          }),
        });
      }
    },
    getDataSource() {
      if (this.datasource) return this.datasource;
      else if (this.items) {
        return new DataSource({
          paginate: true,
          pageSize: 20,
          store: new ArrayStore({
            type: "array",
            data: this.items,
          }),
        });
      } else {
        return undefined;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-auto-complete {
  .auto-complete-secondary {
    padding-left: 5px;
    font-size: 10px;
    color: gray;
  }
  .no-padding {
    padding-left: 0 !important;
  }
}

.gc-grid-description {
  font-size: 14px;
  text-align: left;
  max-height: 2.4em;
  line-height: 1.2;
  overflow: hidden;
}

.record-secondary {
  font-size: 10px;
  text-align: left;
  color: grey;
}
</style>
